import { renderer } from '../Renderer';
import View from '../View';
import Expression from './Expression';

class DataExpression extends Expression {

	target:View;
	template:string;

	constructor( target:View, template:string ) {
		super();
		this.template = template;
		this.target = target;
	}

	update( data:any, attribute:string ) {
		this.target.data = this.value( data );
		this.target.update( attribute ); // update target view if its data has changed
	}

	value( data:{} ) {
		return renderer.render( this.template, data );
	}
}

export default DataExpression;
